import { theme } from '@zappyrent/hundop';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import React, { useContext } from 'react';

import { StyledImage, StyledImageWrapper } from './ReferALandlordHowTo.styles';

const ReferALandlordHowToImage = (): JSX.Element => {
  const { language } = useContext(I18nextContext);

  return (
    <StyledImageWrapper>
      <StyledImage
        alt="Zappyrent"
        src={`${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-1024.jpg`}
        sizes={`
          (max-width: calc(${theme.breakpoints.l} - 1px)) 100vw,
          50vw
        `}
        srcSet={`
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-496.jpg 496w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-768.jpg 768w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-992.jpg 992w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-1024.jpg 1024w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-1536.jpg 1536w,
          ${process.env.GATSBY_CDN_URL}/refer-a-landlord/how-to-${language}-2048.jpg 2048w,
        `}
      />
    </StyledImageWrapper>
  );
};

export default ReferALandlordHowToImage;
